import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SurveyCard } from './survey-card';

@Injectable({
    providedIn: 'root'
})
export class SurveysService {
    constructor(private httpClient: HttpClient) { }

    getSurveys(userAccountId: number): Observable<SurveyCard[]> {
        const profilesUrl = ecorEnv.apiEndpoint + '/secure/profiles/' + userAccountId + '/surveys';
        return this.httpClient.get<SurveyCard[]>(profilesUrl)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('surveys', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('surveys', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
